
export const FileUploadActions = {
    QUEUED: "file-upload/queued",
    PROGRESS: "file-upload/progress",
    COMPLETE: "file-upload/complete",
    ERROR: "file-upload/error",
    CANCEL: "file-upload/cancel",
};

export default FileUploadActions;



// WEBPACK FOOTER //
// ./app/data/FileUploadActions.js